<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const additionalAttributes = computed(
  () => props.inbox?.additional_attributes || {}
);

const historySync = computed(
  () => additionalAttributes.value.coex_sync?.history || null
);

const disconnection = computed(
  () => additionalAttributes.value.coex_disconnection || null
);

const historyProgress = computed(() => {
  const progress = Number(historySync.value?.progress);
  return Number.isFinite(progress) ? progress : null;
});

const statusLabel = computed(() => {
  const labels = {
    pending: t('INBOX_MGMT.COEX.STATUS.pending'),
    in_progress: t('INBOX_MGMT.COEX.STATUS.in_progress'),
    completed: t('INBOX_MGMT.COEX.STATUS.completed'),
    declined: t('INBOX_MGMT.COEX.STATUS.declined'),
    error: t('INBOX_MGMT.COEX.STATUS.error'),
  };
  return labels[historySync.value?.status] || labels.pending;
});

const historyLabel = computed(() => {
  if (historyProgress.value !== null) {
    return t('INBOX_MGMT.COEX.HISTORY_SYNC_PROGRESS', {
      status: statusLabel.value,
      progress: historyProgress.value,
    });
  }
  return t('INBOX_MGMT.COEX.HISTORY_SYNC_STATUS', {
    status: statusLabel.value,
  });
});
</script>

<template>
  <div
    class="flex flex-col gap-3 p-4 mx-8 my-4 border rounded-lg border-n-weak"
  >
    <div class="flex items-center gap-2">
      <span
        class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full text-n-teal-11 bg-n-teal-3"
      >
        {{ t('INBOX_MGMT.COEX.BADGE') }}
      </span>
      <span class="text-sm text-n-slate-11">
        {{ t('INBOX_MGMT.COEX.DESCRIPTION') }}
      </span>
    </div>

    <div v-if="disconnection" class="text-sm font-medium text-n-ruby-11">
      {{ t('INBOX_MGMT.COEX.DISCONNECTED', { event: disconnection.event }) }}
    </div>

    <div v-if="historySync" class="text-sm text-n-slate-12">
      {{ historyLabel }}
    </div>
  </div>
</template>
